var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMexico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 160,
    r: 160,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M320 160c0-63.43-36.92-118.24-90.43-144.12v288.25C283.09 278.25 320 223.44 320 160.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6da544",
    d: "M0 160c0 63.43 36.92 118.24 90.43 144.12V15.88C36.91 41.76 0 96.57 0 160Zm118.26 0c0 23.05 18.69 41.74 41.74 41.74s41.74-18.69 41.74-41.74v-13.91h-83.48V160Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9811",
    d: "M215.65 132.17h-41.74c0-7.68-6.23-13.91-13.91-13.91s-13.91 6.23-13.91 13.91h-41.74c0 7.68 6.69 13.91 14.38 13.91h-.46c0 7.68 6.23 13.91 13.91 13.91 0 7.68 6.23 13.91 13.91 13.91h27.83c7.68 0 13.91-6.23 13.91-13.91 7.68 0 13.91-6.23 13.91-13.91h-.46c7.68 0 14.38-6.23 14.38-13.91Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexico);
export default __webpack_public_path__ + "static/media/Mexico.92d6985e72ab78424c8093e6068dfa54.svg";
export { ForwardRef as ReactComponent };